import { mapGetters } from 'vuex';

export default {
    name: 'mvtWelcome',
    inject: ['$eventBus'],
    computed:{
        ...mapGetters('glb', ['glb', 'getSplit'])
    }
};